module.exports = __webpack_public_path__ + "img/home5-6.90243012.png";